import { render } from "./branch.vue?vue&type=template&id=79c7c56b&scoped=true"
import script from "./branch.vue?vue&type=script&lang=js"
export * from "./branch.vue?vue&type=script&lang=js"

import "./branch.vue?vue&type=style&index=0&id=79c7c56b&lang=scss&scoped=true"
import "./branch.vue?vue&type=style&index=1&id=79c7c56b&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c7c56b"]])

export default __exports__